import BodyMain from "../../components/util/BodyMain";

import { useSelector } from 'react-redux';


const EndUserData = () => {
    const {language} = useSelector(state => state.configuration);
    

    return(
        <>
            <BodyMain>
                <div style={{padding:'20px'}}>
                
                    {
                        language === 'es' ? 
                            <p style={{fontFamily:'arial', fontSize:12}}>
<b style={{display:'flex', justifyContent:'center', width:'100%', fontSize:'16px'}}>POLÍTICA DE PRIVACIDAD DE DATOS DE USUARIO FINAL</b>
<br /><br />Tu privacidad es importante para nosotros. D Luna y nuestras subsidiarias y afiliadas (“D Luna”, 
“nosotros”) recopilamos y procesamos, junto con el/los artista(s) con los que has decidido 
interactuar (“Artista(s)”), cierta información personal sobre ti, y queremos tomarnos un momento 
para explicártelo. Esta política de privacidad (“Política de Privacidad”) está destinada a ayudarte 
a comprender mejor qué información recopilamos, cómo la usamos, almacenamos, compartimos 
y protegemos cuando te registras para recibir las últimas actualizaciones de los artistas. 
<br /><br />¿Quién recopila tus datos? 
<br />D Luna y el/los Artista(s) pueden recopilar y procesar datos personales cuando te registras para 
recibir las últimas actualizaciones de nosotros y/o del/los Artista(s). 
<br /><br />¿Qué tipo de datos? 
<br />D Luna y el/los Artista(s) pueden recopilar los siguientes datos: 
• Tu nombre (si lo proporcionas). 
• Dirección de correo electrónico. 
• Ubicación. 
<br /><br />Fines: 
<br />Una vez registrado, tus datos podrán ser recopilados y utilizados para: 
<br />• Enviarte actualizaciones y noticias del/de los artista(s) que sigues. 
<br />• Comprender el nivel de interacción general de los fans a través de estadísticas y análisis. 
<br />• Compartirte música, artistas similares y otra información relacionada que creemos pueda 
interesarte, de acuerdo con tus preferencias e interacciones. 
<br /><br />Cómo podemos usar tu información (D Luna y los Artista(s)) 
Tus datos serán almacenados de manera segura y compartidos únicamente con el/los artista(s) 
que hayas elegido seguir o con los que decidas interactuar. Dichos artistas podrán contactarte 
para compartir novedades musicales, contenido exclusivo u otras noticias relacionadas con su 
comunidad de fans. D Luna también podrá contactarte ocasionalmente con información que creemos disfrutarás y te 
será de utilidad. 
<br /><br />Transferencias internacionales de tus datos 
<br /><br />Podemos almacenar o procesar tus datos personales en países fuera del tuyo, incluyendo fuera de 
la UE/EEE. En esos casos, garantizaremos que tu información sea manejada de forma segura y 
en conformidad con las leyes de protección de datos aplicables. 
<br /><br />Conservación de datos 
<br /><br />Conservamos tus datos mientras sea necesario para cumplir los fines establecidos en esta Política 
de Privacidad o hasta que solicites su eliminación. 
<br /><br />Tus derechos 
<br /><br />Puedes retirar tu consentimiento o solicitar en cualquier momento acceso, corrección o 
eliminación de tus datos personales contactando tanto al/los Artista(s) como a D Luna en:        
<b>dluna@dlunamusic.com</b> 
<br /><br />Ten en cuenta que D Luna solo puede procesar solicitudes relacionadas con los datos que 
almacenamos en nuestros sistemas. Cualquier consulta enviada directamente al/los Artista(s) será 
responsabilidad de ellos, y D Luna no puede garantizar su respuesta. 
<br /><br />Última actualización: 16 de agosto de 2025
                            </p>
                        :
                            <p style={{fontFamily:'arial', fontSize:12}}>
<b style={{display:'flex', justifyContent:'center', width:'100%', fontSize:'16px'}}>END USER DATA PRIVACY POLICY</b>
<br /><br />Your privacy matters to us. D Luna and our subsidiaries and affiliates (“D Luna”, “we”, “us”) 
collect and process, together with the artist(s) you have chosen to engage with (“Artist(s)”), 
some personal information about you and we want to take some time to tell you about it. This 
privacy policy (“Privacy Policy”) is intended to help you better understand what and how we 
collect, use, store, share and protect your information when you’ve registered to receive the latest 
updates from artist(s). 
<br /><br />Who is collecting your data? 
<br />Amuse and the Artist(s) may collect and process personal data when you have registered to 
receive the latest updates from us and/or the Artist(s).  
<br /><br />What kind of data?  
<br />We and the Artist(s) may collect the following data: 
<br />• your name (if provided),  
<br />• email address; and 
<br />• location  
<br /><br />Purposes: 
<br />Once you have registered, your data may be collected and used to: 
<br />• Send you updates and news from the artist(s) you follow:  
<br />• Understand general fan engagement through statistics and insights: and 
<br />• share similar artists, music and other related information we think you might like, based 
on your preferences and interactions. 
<br /><br />How we and the Artist(s) may use your information 
<br /><br />Your data will be securely stored and shared only with the artist(s) you’ve chosen to follow or 
engage with. These artist(s) may contact you to share the latest music updates, exclusive content, 
or other fan-related news. 
<br /><br />D Luna may also contact you occasionally with information we believe you'll enjoy and benefit 
from. 
<br /><br />International transfers of your data 
<br /><br />We may store or process your personal data in countries outside your own, including outside the 
EU/EEA. If that happens, we’ll make sure your information is handled securely and in line with 
applicable data protection laws. 
<br /><br />Data retention 
<br /><br />We keep your data for as long as needed to fulfill the purposes under this Privacy Policy or until 
you ask us to delete it. 
<br /><br />Your rights 
<br /><br />You can withdraw your consent or request access to, correction of, or deletion of your personal 
data at any time by contacting both the Artist(s) and D Luna at <b>dluna@dlunamusic.com</b>   
<br /><br />Please note that D Luna can only process requests related to data held in our systems. Any 
inquiries sent directly to the Artist(s) will be their responsibility to manage, and D Luna cannot 
guarantee their response.  
<br /><br />Last updated: August 16th, 2025
                            </p>
                    }

                </div>
            </BodyMain>
        </>
    )
}

export default EndUserData;